import React from 'react';
import { useContent } from '../../hooks/useContent';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorMessage from '../common/ErrorMessage';

const DiscoverSection = () => {
    const { content, isLoading, isError, error, loadContentBySection } = useContent('service');

    // Get the service content data
    const serviceData = content.length > 0 ? content[0].content_data : null;

    if (isLoading) {
        return (
            <section className="section discover-area bg-gray overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <LoadingSpinner size="lg" />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (isError) {
        return (
            <section className="section discover-area bg-gray overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <ErrorMessage error={error} onRetry={() => loadContentBySection('service')} />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (!serviceData) {
        return (
            <section className="section discover-area bg-gray overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="text-center">
                                <p>No service content available.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="section discover-area bg-gray overflow-hidden ptb_100">
            <div className="container">
                <div className="row justify-content-between align-items-center">
                    <div className="col-12 col-lg-6 order-2 order-lg-1">
                        {/* Discover Thumb */}
                        <div className="service-thumb discover-thumb mx-auto mt-4 mt-lg-0">
                            <img src={serviceData.thumbFour} alt="Service Thumbnail" />
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 order-1 order-lg-2">
                        {/* Discover Text */}
                        <div className="discover-text pt-4 pt-lg-0 px-0 px-lg-4">
                            <h2 className="pb-4">{serviceData.headingFour}</h2>
                            {/* Service List */}
                            <ul className="service-list style-two">
                                {serviceData.serviceData && serviceData.serviceData.map((item, idx) => (
                                    <li key={`sf_${idx}`} className="single-service py-2">
                                        <div className="service-text">
                                            <p>{item.text}</p>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DiscoverSection;